import { Model as s } from "../../../../model.js";
class h extends s {
  constructor(o) {
    super(), this.shop = o.shop, this.checkout = o.checkout, this.payment = o.payment;
  }
}
export {
  h as ShopSessionConfigurationModel
};
//# sourceMappingURL=configuration.model.js.map
